import type {IPhoneFieldValue} from "@pg-design/phone-input-module";
import {pickBy} from "@pg-mono/nodash";

import {CreditApplicationSource} from "../../credit_calculator/types/CreditApplicationSource";
import type {ICreditData, ICreditRatingData} from "../../credit_calculator/types/ICreditData";
import {getOfferTypeNameCapital} from "../../offer/helpers/OfferType";
import {rpFinancialApplicationConsents} from "../constants/rp_financial_application_consents";
import {
    FINANCIAL_APPLICATION_SOURCE_RP_LABEL,
    FinancialApplicationSource,
    type ICreateFinancialApplicationRequest,
    ServiceType
} from "../types/financial_application";
import {getCalculatorFinancialApplicationFieldLabel, getCalculatorFinancialApplicationFieldSortIndex} from "./get_calculator_financial_application_field_label";

const META_FRONTEND_VERSION = "rp-web";

function mapCreditApplicationSourceToFinancialApplicationSource(source: CreditApplicationSource): FinancialApplicationSource {
    switch (source) {
        case CreditApplicationSource.MORTGAGE_APPLICATION_SOURCE_CREDIT:
            return FinancialApplicationSource.RP_INSTALLMENT_CALCULATOR;
        case CreditApplicationSource.MORTGAGE_APPLICATION_SOURCE_CREDIT_RATING:
            return FinancialApplicationSource.RP_CREDITWORTHINESS_CALCULATOR;
        default:
            return FinancialApplicationSource.RP_INSTALLMENT_CALCULATOR;
    }
}

function isPresentCalculatorSubmitValue(value: unknown): boolean {
    return value !== undefined && value !== null && value !== "";
}

function compareCalculatorSubmitFieldKeys(keyA: string, keyB: string): number {
    const orderDiff = getCalculatorFinancialApplicationFieldSortIndex(keyA) - getCalculatorFinancialApplicationFieldSortIndex(keyB);
    if (orderDiff !== 0) {
        return orderDiff;
    }
    return keyA.localeCompare(keyB);
}

function formatCalculatorFieldValue(key: string, value: unknown): string {
    if (key === "property_type" && typeof value === "number") {
        return getOfferTypeNameCapital(value);
    }
    return String(value);
}

function formatCalculatorFieldsAsText(submitData: ICreditData | ICreditRatingData): string {
    const {source: _source, ...rest} = submitData;
    const fieldsWithValues = pickBy(rest as Record<string, unknown>, isPresentCalculatorSubmitValue);
    const entries = Object.entries(fieldsWithValues);

    entries.sort(([keyA], [keyB]) => compareCalculatorSubmitFieldKeys(keyA, keyB));

    return entries.map(([key, value]) => `${getCalculatorFinancialApplicationFieldLabel(key)}: ${formatCalculatorFieldValue(key, value)}`).join("\n");
}

function phoneToString(phone: IPhoneFieldValue): string {
    return `${phone.code}${phone.number}`;
}

export function buildRpFinancialApplicationPayload(params: {
    name: string;
    email: string;
    phone: IPhoneFieldValue;
    submitData: ICreditData | ICreditRatingData;
}): ICreateFinancialApplicationRequest {
    const financialSource = mapCreditApplicationSourceToFinancialApplicationSource(params.submitData.source);

    return {
        name: params.name,
        email: params.email,
        phone: phoneToString(params.phone),
        meta: {
            author: FINANCIAL_APPLICATION_SOURCE_RP_LABEL[financialSource as keyof typeof FINANCIAL_APPLICATION_SOURCE_RP_LABEL],
            frontend_version: META_FRONTEND_VERSION
        },
        consents: rpFinancialApplicationConsents,
        source: financialSource,
        service_type: ServiceType.MORTGAGE,
        text: formatCalculatorFieldsAsText(params.submitData)
    };
}
import type {IPhoneFieldValue} from "@pg-design/phone-input-module";
import {pickBy} from "@pg-mono/nodash";

import {CreditApplicationSource} from "../../credit_calculator/types/CreditApplicationSource";
import type {ICreditData, ICreditRatingData} from "../../credit_calculator/types/ICreditData";
import {getOfferTypeNameCapital} from "../../offer/helpers/OfferType";
import {rpFinancialApplicationConsents} from "../constants/rp_financial_application_consents";
import {
    FINANCIAL_APPLICATION_SOURCE_RP_LABEL,
    FinancialApplicationSource,
    type ICreateFinancialApplicationRequest,
    ServiceType
} from "../types/financial_application";
import {getCalculatorFinancialApplicationFieldLabel, getCalculatorFinancialApplicationFieldSortIndex} from "./get_calculator_financial_application_field_label";

const META_FRONTEND_VERSION = "rp-web";

function mapCreditApplicationSourceToFinancialApplicationSource(source: CreditApplicationSource): FinancialApplicationSource {
    switch (source) {
        case CreditApplicationSource.MORTGAGE_APPLICATION_SOURCE_CREDIT:
            return FinancialApplicationSource.RP_INSTALLMENT_CALCULATOR;
        case CreditApplicationSource.MORTGAGE_APPLICATION_SOURCE_CREDIT_RATING:
            return FinancialApplicationSource.RP_CREDITWORTHINESS_CALCULATOR;
        default:
            return FinancialApplicationSource.RP_INSTALLMENT_CALCULATOR;
    }
}

function isPresentCalculatorSubmitValue(value: unknown): boolean {
    return value !== undefined && value !== null && value !== "";
}

function compareCalculatorSubmitFieldKeys(keyA: string, keyB: string): number {
    const orderDiff = getCalculatorFinancialApplicationFieldSortIndex(keyA) - getCalculatorFinancialApplicationFieldSortIndex(keyB);
    if (orderDiff !== 0) {
        return orderDiff;
    }
    return keyA.localeCompare(keyB);
}

function formatCalculatorFieldValue(key: string, value: unknown): string {
    if (key === "property_type" && typeof value === "number") {
        return getOfferTypeNameCapital(value);
    }
    return String(value);
}

function formatCalculatorFieldsAsText(submitData: ICreditData | ICreditRatingData): string {
    const {source: _source, ...rest} = submitData;
    const fieldsWithValues = pickBy(rest as Record<string, unknown>, isPresentCalculatorSubmitValue);
    const entries = Object.entries(fieldsWithValues);

    entries.sort(([keyA], [keyB]) => compareCalculatorSubmitFieldKeys(keyA, keyB));

    return entries.map(([key, value]) => `${getCalculatorFinancialApplicationFieldLabel(key)}: ${formatCalculatorFieldValue(key, value)}`).join("\n");
}

function phoneToString(phone: IPhoneFieldValue): string {
    return `${phone.code}${phone.number}`;
}

export function buildRpFinancialApplicationPayload(params: {
    name: string;
    email: string;
    phone: IPhoneFieldValue;
    submitData: ICreditData | ICreditRatingData;
}): ICreateFinancialApplicationRequest {
    const financialSource = mapCreditApplicationSourceToFinancialApplicationSource(params.submitData.source);

    return {
        name: params.name,
        email: params.email,
        phone: phoneToString(params.phone),
        meta: {
            author: FINANCIAL_APPLICATION_SOURCE_RP_LABEL[financialSource as keyof typeof FINANCIAL_APPLICATION_SOURCE_RP_LABEL],
            frontend_version: META_FRONTEND_VERSION
        },
        consents: rpFinancialApplicationConsents,
        source: financialSource,
        service_type: ServiceType.MORTGAGE,
        text: formatCalculatorFieldsAsText(params.submitData)
    };
}
